import { render } from "./CRMGeneral.vue?vue&type=template&id=7eaaf75c"
import script from "./CRMGeneral.vue?vue&type=script&lang=js"
export * from "./CRMGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__